<template>
    <div class="logins">
      <div class="box">
        <img src="../assets/icon1.png">
      </div>
      <div class="flex">
        <div class="option">
          <div class="icon1"></div>
          <div>账号:</div>
          <input type="text" v-model="account"  @input="bindaccount">
        </div>
        <div class="option">
          <div class="icon2"></div>
          <div>密码:</div>
          <input type="password" v-model="password"  @input="bindpassword">
        </div>
        <div class="tips" v-if="show">账号或密码不正确，请重新输入</div>
      </div>
      <div class="login"  @click="login">登录</div>
    </div>
</template>

<script>
    export default {
        name: "login",
        data () {
          return {
            account:'',
            password:'',
            show:false

          }
        },
        methods:{
          bindaccount(e){
            console.log(this.account)
            //this.account=''
          },
          bindpassword(e){
            console.log(this.password)
            //this.account=''
          },
          login(){

          }
        }
    }
</script>

<style scoped>
  /*公共样式-szs*/
  html{font-size:62.5%;}
  body, h1, h2, h3, h4, h5, h6, hr, p, blockquote, dl, dt, dd, ul, ol, li, pre, form, fieldset, legend, button, input, textarea, th, td {
    margin: 0;
    padding: 0;
    vertical-align: baseline;
  }
  html{
    width:100%;
    height:100%;
  }
  ul{
    list-style:none;
  }
  .clear{clear:both;}
  body {
    color: #000;
    font-family:Microsoft YaHei;
    font-size:62.5%;
    width:100%;
    height: 100%;
    line-height: 1;
    margin: 0 auto;
    background-color:#fff;
    overflow: hidden;
  }
  *{
    -webkit-tap-highlight-color:rgba(0, 0, 0, 0);
  }
  .contains{
    width:100%;
  }
  .box{
    width:5.39rem;
    overflow: hidden;
    margin:2rem auto 0;
  }
  .box img{
    width:100%;
    display: block;
  }
  .flex{
    width:5.1rem;
    margin:0.93rem auto 0;
  }
  .option{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height:0.85rem;
    line-height:0.85rem;
    width:100%;
    border:1px solid #030303;
    border-radius: 10px;
    font-size:0.3rem;
    margin-top:0.36rem;
    padding-left:0.4rem;
  }
  .option input{
    line-height:0.85rem;
    border:none;
    padding-left:0.2rem;
    outline:none;
  }
  .icon1{
    width:0.24rem;
    height:0.27rem;
    background: url(../assets/icon3.png) no-repeat center top;
    background-size: 100%;
    margin-right:0.2rem;
  }
  .icon2{
    width:0.25rem;
    height:0.29rem;
    background: url(../assets/icon2.png) no-repeat center top;
    background-size: 100%;
    margin-right:0.2rem;
  }
  .login{
    width:5.1rem;
    height:0.85rem;
    line-height:0.85rem;
    background-color:#F6A800;
    border-radius:10px;
    text-align:center;
    font-size:0.3rem;
    color:#fff;
    margin:1.1rem auto 0;
  }
  .tips{
    color:red;
    font-size:0.22rem;
    text-align:left;
    margin:10px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/login.vue